// extracted by mini-css-extract-plugin
module.exports = {"duckloader":"Loader_duckloader__2phX4","canard":"Loader_canard__25Xap","vague":"Loader_vague__11uta","vagueBack":"Loader_vagueBack__ZfW2q","vagueFront":"Loader_vagueFront__sGI0C"};